import $ from 'jquery';

$('.slider__slider').slick({
    dots: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: false,
    // prevArrow: "<img class='slick-prev pull-left' src='/wp-content/themes/diament/gfx/slide_arr.svg' alt='arrow' />",
    // nextArrow: "<img class='slick-next pull-right' src='/wp-content/themes/diament/gfx/slide_arr.svg' alt='arrow' />",
    swipeToSlide: true,
});   


$('.of__slick').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToScroll: 1,
    slidesToShow: 2,
    arrows: false,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.gal__gallery').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 7000,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img src='/wp-content/themes/pozwolenie/assets/gfx/arr.png' alt='arr'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img src='/wp-content/themes/pozwolenie/assets/gfx/arr.png' alt='arr' /></button>",
    slidesToShow: 3,
    arrows: true,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});
$('.ct__count').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 7000,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img src='/wp-content/themes/pozwolenie/assets/gfx/arr.png' alt='arr'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img src='/wp-content/themes/pozwolenie/assets/gfx/arr.png' alt='arr' /></button>",
    slidesToShow: 3,
    arrows: true,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1224,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots:true,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots:true,
            }
        },
        {
            breakpoint: 600,
            settings: {
                dots:true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.ws__map').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 7000,
    slidesToScroll: 1,
    slidesToShow: 5,
    arrows: false,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots:true,
            }
        },
        {
            breakpoint: 1022,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots:true,
            }
        },
        {
            breakpoint: 600,
            settings: {
                dots:true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.pl__wrapper').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 7000,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img src='/wp-content/themes/pozwolenie/assets/gfx/arr.png' alt='arr'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img src='/wp-content/themes/pozwolenie/assets/gfx/arr.png' alt='arr' /></button>",
    slidesToShow: 4,
    arrows: true,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.related__loop .loop').slick({
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 7000,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: false,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 600,
            settings: {
                dots:true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});